export default {
    when() {
        return document.querySelectorAll('.cursor').length > 0;
    },

    mounted() {
        const $cursor = $('.cursor');

        // 1. Déplacement du curseur sur la souris
        $(window).on('mousemove', function(e) {
            $cursor.css({
                top: e.clientY - $cursor.height() / 2,
                left: e.clientX - $cursor.width() / 2
            });
        });

        // 2. Délégation d'événements (fonctionne aussi sur le contenu injecté en AJAX)
        $(document)
            .on('mouseenter', '.has-cursor', function() {
                $cursor.removeClass('hidden');
            })
            .on('mouseleave', '.has-cursor', function() {
                $cursor.addClass('hidden');
            });
    },
};